import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { RetrievalResultReportState } from '../types';

/**
 * 检索结果报告模型
 * @description 检索结果报告模型
 */
export interface FtoReportRetrievalResultReportModel extends Model<RetrievalResultReportState>, Disposable {

}

export const FtoReportRetrievalResultReportModel = Symbol.for('FtoReportRetrievalResultReportModel');
